// The November challenge's dates, Paris time. Mirrors CHALLENGE_COHORT_START_AT
// and CHALLENGE_COHORT_SIGNUP_CLOSES_AT in server.py; the challenge page
// prefers the server's copy once it has it.

// Day 1, midnight.
export const CHALLENGE_STARTS = '2026-11-02T00:00:00+01:00';
// Sign-ups stay open until the end of 20 November.
export const CHALLENGE_CLOSES = '2026-11-21T00:00:00+01:00';
